<template>
    <div class="fade-in results-none d-flex flex-column text-center">
        <h2 class="fs-3 fw-bold">
            {{ message }}
        </h2>
        <p class="fw-thin fs-5">
            {{ subMessage }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'EmptySearchResults',
    props: {
        message: {
            type: String,
            required: true
        },
        subMessage: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
    .fade-in{-webkit-animation:fade-in .7s cubic-bezier(.39,.575,.565,1.000) both;animation:fade-in .7s cubic-bezier(.39,.575,.565,1.000) both}
</style>



// WEBPACK FOOTER //
// src/components/blocks/EmptySearchResults.vue